<template>
  <!-- <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-1">
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#">خانه</a>
              </li>
              <li class="breadcrumb-item active">داشبورد</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-primary">
              <form role="form">
                <div class="card-body">
                  <table class="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th class="p-2 bg-light">نام</th>
                        <th class="p-2 bg-light">نام خانوادگی</th>
                        <th class="p-2 bg-light">ایمیل</th>
                        <th class="p-2 bg-light">موبایل</th>
                        <th class="p-2 bg-light">عملیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="user in userList" :key="user.Email">
                        <td class="p-1">{{user.FirstName}}</td>
                        <td class="p-1">{{user.LastName}}</td>
                        <td class="p-1">{{user.Email}}</td>
                        <td class="p-1">{{user.Mobile}}</td>
                        <td class="p-1">
                          <a href="#" class="p-1" @click="openChangeUserPasswordModal(user._id)">
                            <i class="fa fa-key text-secondary table-opration"></i>
                          </a>
                          <a href="#" class="p-1" @click="getUser(user._id)">
                            <i class="fa fa-edit text-secondary table-opration"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="modal fade" id="div_UserInfoModal">
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content border-0">
          <div class="modal-header p-2 bg-info">
            <h6 class="modal-title text-white">اطلاعات کاربر</h6>
          </div>
          <div class="modal-body text-center">
            <div style="height:400px;overflow-y:scroll">
              <form>
                <div class="form-group row m-0">
                  <label for="EditFirstName" class="col-3 col-form-label">نام</label>
                  <div class="col-9 text-right align-self-center">
                    <span>{{userInfo.FirstName}}</span>
                  </div>
                </div>
                <div class="form-group row m-0">
                  <label for="EditLastName" class="col-3 col-form-label">نام خانوادگی</label>
                  <div class="col-9 text-right align-self-center">
                    <span>{{userInfo.LastName}}</span>
                  </div>
                </div>
                <div class="form-group row m-0">
                  <label for="EditEmail" class="col-3 col-form-label">ایمیل</label>
                  <div class="col-9 text-right align-self-center">
                    <span>{{userInfo.Email}}</span>
                  </div>
                </div>
                <div class="form-group row m-0">
                  <label for="EditMobile" class="col-3 col-form-label">موبایل</label>
                  <div class="col-9 text-right align-self-center">
                    <span>{{userInfo.Mobile}}</span>
                  </div>
                </div>
                <div class="form-group row m-0">
                  <label for="EditAddress" class="col-3 col-form-label">آدرس</label>
                  <div class="col-9 text-right align-self-center">
                    <span>{{userInfo.Address}}</span>
                  </div>
                </div>
                <div class="form-group row m-0">
                  <label for="EditNationalCode" class="col-3 col-form-label">کدملی</label>
                  <div class="col-9 text-right align-self-center">
                    <span>{{userInfo.NationalCode}}</span>
                  </div>
                </div>
                <div class="form-group row m-0">
                  <label for="EditPostalCode" class="col-3 col-form-label">کدپستی</label>
                  <div class="col-9 text-right align-self-center">
                    <span>{{userInfo.PostalCode}}</span>
                  </div>
                </div>
                <div class="form-group row m-0">
                  <label for="EditRegisterDate" class="col-3 col-form-label">تاریخ ثبت نام</label>
                  <div class="col-9 text-right align-self-center">
                    <span>{{ userInfo.RegisterDate | moment("jYYYY/jM/jD HH:mm") }}</span>
                  </div>
                </div>
                <div class="form-group row m-0">
                  <label for="EditUserActive" class="col-3 col-form-label">وضعیت کاربر</label>
                  <div class="col-9 text-right align-self-center">
                    <span>{{userInfo.UserActive==true?"فعال":"غیرفعال"}}</span>
                    <p-check
                      name="check"
                      color="success"
                      v-model="userInfo.UserActive"
                      @change="updateUser(userInfo._id)"
                      checked
                    ></p-check>
                  </div>
                </div>
                <div class="form-group row m-0">
                  <label for="EditRoles" class="col-12 col-form-label text-right">نقش های کاربر</label>
                  <div class="col-12 text-right align-self-center">
                    <div v-for="role in systemRoles" :key="role.Role">
                      <span>{{role.Title}}</span>
                      <p-check
                        name="check"
                        color="success"
                        v-model="userRoles"
                        :value="role.Role"
                        @change="updateUser(userInfo._id)"
                      ></p-check>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer p-2">
            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">بستن</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="div_ChangeUserPasswordModal">
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content border-0">
          <div class="modal-header p-2 bg-info">
            <h6 class="modal-title text-white">تغییر رمز عبور</h6>
            <a href="#" class="text-left" data-dismiss="modal">بستن</a>
          </div>
          <div class="modal-body text-center">
            <form v-on:submit.prevent="changeUserPassword(userId)">
              <div class="form-group row m-0">
                <label for="EditNewPassword" class="col-3 col-form-label">رمز عبور جدید</label>
                <div class="col-9 text-right align-self-center">
                  <input
                    type="password"
                    class="form-control text-left"
                    id="EditNewPassword"
                    v-model="newPassword"
                  />
                </div>
              </div>
              <div class="form-group row m-0">
                <div class="col-12 mt-4">
                  <button type="submit" class="btn btn-success btn-block">تغییر بده</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>-->

  <!-- <div class="body_scroll">
    <div class="block-header">
      <div class="row">
        <div class="col-lg-7 col-md-6 col-sm-12">
          <h2>شروع کننده صفحه</h2>
          <ul class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="index.html">
                <i class="zmdi zmdi-home"></i> آئرو
              </a>
            </li>
            <li class="breadcrumb-item active">صفحات</li>
            <li class="breadcrumb-item active">شروع کننده صفحه</li>
          </ul>
          <button class="btn btn-primary btn-icon mobile_menu" type="button">
            <i class="zmdi zmdi-sort-amount-desc"></i>
          </button>
        </div>
        <div class="col-lg-5 col-md-6 col-sm-12">
          <button class="btn btn-primary btn-icon float-right right_icon_toggle_btn" type="button">
            <i class="zmdi zmdi-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row clearfix">
        <div class="col-lg-12">
          <div class="card">
            <div class="header">
              <h2>
                <strong>صفحه</strong> شروع
              </h2>
            </div>
            <div class="body">
              <h5>صفحه شروع</h5>
              <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>-->
  <section class="content">
    <BlockUI v-show="loadingShow">
      <div class="spinner-border text-info"></div>
      <p>شکیبا باشید...</p>
    </BlockUI>
    <div class="body_scroll">
      <div class="block-header">
        <div class="row">
          <div class="col-lg-5 col-md-5 col-sm-12">
            <h2>مدیریت کاربران</h2>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="Dashboard">
                  <i class="zmdi zmdi-home"></i>پنل مدیریت
                </a>
              </li>
              <li class="breadcrumb-item active">
                <a href="#" @click="getUserList">مدیریت کاربران</a>
              </li>
            </ul>
            <button class="btn btn-primary btn-icon mobile_menu" type="button">
              <i class="zmdi zmdi-sort-amount-desc"></i>
            </button>
          </div>
          <div class="col-lg-7 col-md-7 col-sm-12">
            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button">
              <i class="zmdi zmdi-arrow-right align-middle"></i>
            </button>
            <button
                class="btn btn-success float-right right_icon_toggle_btn"
                type="button"
                title="کاربر جدید"
                data-color="red"
                @click="openNewUserModal()"
            >
              <i class="zmdi zmdi-account-add align-middle"></i>
              کاربر جدید
            </button>
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="درج ‌از فایل‌ اکسل"
                            data-color="red"
                            @click="openNewUserFromExcelModal()"
                        >
                          <i class="zmdi zmdi-accounts-add align-middle"></i>
                          درج‌ از فایل ‌اکسل
                        </button>-->
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="بروزرسانی حساب‌های مشتریان"
                            data-color="red"
                            @click="openUpdateUserCashModal()"
                        >
                          <i class="zmdi zmdi-accounts-add align-middle"></i>
                          بروزرسانی حساب‌های مشتریان
                        </button>-->

<!--            <button
                class="btn btn-success float-right right_icon_toggle_btn"
                type="button"
                title="جستجوی کاربر"
                data-color="red"
                @click="openUserSearchModal()"
            >
              <i class="zmdi zmdi-search align-middle"></i>
              جستجوی کاربر
            </button>
            <button
                class="btn btn-danger float-right right_icon_toggle_btn"
                type="button"
                title="جستجوی کاربر"
                data-color="red"
                @click="removeUserSearchMode()" v-if="userSearchMode"
            >
              <i class="zmdi zmdi-accounts align-middle"></i>
              نمایش همه
            </button>-->
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row clearfix">
          <div class="col-lg-12">
            <div class="card">
<!--              <div class="row">
                <div class="col-lg-12">
                  <select v-model="pageSize">
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>-->

              <div class="body">
                <div class="table-responsive">
                  <table
                      class="table table-bordered table-striped table-hover"
                  >
                    <thead class="bg-muted">
                    <tr>
                      <th class="p-1 text-center">نام</th>
                      <th class="p-1 text-center">نام کاربری</th>
                      <th class="p-1 text-center">تاریخ ایجاد</th>
                      <th class="p-1 text-center">شناسه بله</th>
                      <th class="p-1 text-center">عملیات</th>
                    </tr>
                    </thead>

                    <tbody class="text-center">
                    <tr v-for="user in userData.UserList" :key="user.UserName">
                      <td class="p-1 align-middle">{{ user.FullName }}</td>
                      <td class="p-1 align-middle">{{ user.UserName }}</td>
                      <td class="p-1 align-middle">{{ $formatDateTime(user.CreationDate) | moment("jYYYY/jMM/jDD") }}</td>
                      <td class="p-1 align-middle">{{ user.BaleUID }}</td>
                      <!--                      <td class="p-1 align-middle">
                                                                      <span v-if="user.CardNumber"
                                                                            style="direction: ltr;display: inline-block">
                                                                         {{ splitDebitCartNumber(user.CardNumber) }}
                                                                      </span>

                                            </td>-->
                      <!--                      <td class="p-1 align-middle" style="direction: ltr;">{{ splitDigit(user.Cash) }}</td>
                                            <td class="p-1 align-middle" style="direction: ltr;">{{ splitDigit(user.Wallet) }}</td>-->
<!--                      <td class="p-1 align-middle">{{ user.UserActive == true ? "فعال" : "غیرفعال" }}</td>-->
<!--                      <td class="p-1 align-middle">
                                                <span :class="{'text-danger':!user.SendSms}">
                                                    {{ user.SendSms == true ? "فعال" : "غیرفعال" }}
                                                </span>
                      </td>-->
                      <!--                      <td class="p-1 align-middle">
                                            <span>
                                              {{ user.AutoGenerateCardNumber == true ? "سیستمی" : "بانکی" }}
                                            </span>
                                            </td>-->
<!--                      <td class="p-1 align-middle">
                        {{ user.RegisterDate | moment("jYYYY/jM/jD-HH:mm") }}
                      </td>-->
                      <!--                      <td class="p-1 align-middle">
                                              <span :class="{'text-danger':!user.IsRegisterComplete}">
                                                                          {{ user.IsRegisterComplete == true ? "بله" : "خیر" }}
                                                                      </span>
                                            </td>-->
                      <td class="p-1">
                        <a
                            href="#"
                            @click="openEditRolesUser(user.Id)"
                            class="m-1 btn btn-primary btn-sm" title="نقش های کاربر"
                        >
                          <i class="zmdi zmdi-settings align-middle text-white"></i>
                        </a>
                        <!-- <a
                                 href="#"
                                 class="m-1 btn btn-primary btn-sm"
                                 @click="openChangeUserPasswordModal(user._id)"
                                 title="تغییر رمز عبور"
                         >
                             <i class="zmdi zmdi-key align-middle text-white"></i>
                         </a>-->
<!--                        <a
                            href="#"
                            class="m-1 btn btn-primary btn-sm"
                            @click="openEditPermissionsModal(user._id)"
                            title="مجوزهای کاربر"
                        >
                          <i class="zmdi zmdi-account align-middle text-white"></i>
                        </a>-->
<!--                        <a
                            href="#"
                            class="m-1 btn btn-primary btn-sm"
                            @click="openUserInfoModal(user._id)" title="اطلاعات کاربری"
                        >
                          <i class="zmdi zmdi-info-outline align-middle text-white"></i>
                        </a>-->
                        <!--                        <a
                                                    href="#"
                                                    class="m-1 btn btn-success btn-sm"
                                                    @click="openUserCashModal(user._id)" title="مدیریت موجودی حساب"
                                                >
                                                  <i class="zmdi zmdi-money align-middle text-white"></i>
                                                </a>-->
                        <a
                            href="#"
                            class="m-1 btn btn-primary btn-sm"
                            @click="openEditCustomerModal(user.Id)"
                            title="ویرایش اطلاعات مشتری"
                        >
                          <i class="zmdi zmdi-edit align-middle text-white"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <!--<ul
                    class="pagination pagination-warning d-flex flex-row justify-content-center align-items-center"
            >
                <li
                        class="page-item"
                        v-for="item in pageList"
                        :key="item"
                        :class="{ 'active': pageIndex === item }"
                >
                    <a class="page-link" href="#" @click="getUserList(item,pageSize)">{{item}}</a>
                </li>
            </ul>-->
<!--            <paginate
                :page-count="pageList"
                :click-handler="getUserList"
                :prev-text="'prev'"
                :next-text="'next'" :page-range="10"
                :container-class="'custom-pagination'">
            </paginate>-->
          </div>
        </div>
      </div>
      <div class="modal fade" id="div_NewUserModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header justify-content-between pt-3">
              <span class="title">کاربر جدید</span>
              <span data-dismiss="modal" class="btn btn-link text-muted">بستن</span>
            </div>
            <div class="modal-body">
              <simplebar
                  class="col-xl-12"
                  data-simplebar-auto-hide="false"
                  style="max-height:400px;"
              >
                <form @submit.prevent="addUser()">
                  <label>نام</label>
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="userFields.FirstName"
                           required/>
                  </div>
                  <label>نام خانوادگی</label>
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="userFields.LastName" required/>
                  </div>

                  <label>جنسیت</label>
                  <div class="form-group">
                    <select
                        class="form-control show-tick ms select2"
                        data-placeholder="انتخاب"
                        style="height:auto;"
                        v-model="userFields.Gender" required
                    >
                      <option value="1">آقا</option>
                      <option value="0">خانم</option>
                    </select>
                  </div>

                  <label>شماره همراه</label>
                  <div class="form-group">
                    <input type="number" class="form-control text-left" v-model="userFields.Mobile"
                           required maxlength="11"/>
                  </div>


                  <!--                  <label>شماره کارت</label>
                                    <div class="form-group">
                                      <div class="checkbox">
                                        <input id="chb_AutoCardNumber" type="checkbox" v-model="userFields.AutoGenerateCardNumber"/>
                                        <label for="chb_AutoCardNumber">
                                          تولید شماره کارت سیستمی
                                        </label>
                                      </div>
                                      <input type="text" class="form-control text-left"
                                             v-model="userFields.CardNumber" :disabled="userFields.AutoGenerateCardNumber"/>
                                    </div>-->

<!--                  <label>کد ملی</label>
                  <div class="form-group">
                    <input type="text" class="form-control text-left"
                           v-model="userFields.NationalCode" required maxlength="10"/>
                  </div>-->

                  <label>رمز عبور</label>
                  <div class="form-group">
                    <input type="password" class="form-control text-left"
                           v-model="userFields.Password" required minlength="3"/>
                  </div>


                  <!--                  <label>سازمان طرف قرارداد</label>
                                    <div class="form-group">
                                      <v-select
                                          :getOptionLabel="option => option.Title"
                                          :options="organizationCategory" v-model="userFields.OrganizationCategory"
                                      >
                                        <template slot="option" slot-scope="option">
                                          <span class="fa">{{ `${option.Title}` }}</span>
                                        </template>
                                      </v-select>

                                    </div>-->

                  <!-- <label>ایمیل/نام کاربری</label>
                   <div class="form-group">
                       <input type="text" class="form-control text-left" v-model="userFields.Email"/>
                   </div>
                   <label>رمزعبور</label>
                   <div class="form-group">
                       <input
                               type="password"
                               class="form-control text-left"
                               v-model="userFields.Password"
                               v-if="authType=='Tradition'"
                       />
                   </div>-->
<!--                  <div class="checkbox">
                    <input id="chb_AddUserStatus" type="checkbox" v-model="userFields.UserActive"/>
                    <label for="chb_UserStatus">
                      وضعیت کاربر
                      {{ (userFields.UserActive == true ? "فعال" : "غیرفعال") }}
                    </label>
                  </div>-->
                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >ذخیره کن
                  </button>
                </form>
              </simplebar>
            </div>
            <!-- <div class="modal-footer">
            <button type="button" class="btn btn-default btn-round waves-effect">ذخیره تغییرات</button>
            <button
              type="button"
              class="btn btn-danger btn-round waves-effect"
              data-dismiss="modal"
            >بستن</button>
            </div>-->
          </div>
        </div>
      </div>

      <div class="modal fade" id="div_NewUsersFromExcelModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header justify-content-between pt-3">
              <span class="title">خواندن ازفایل اکسل</span>
              <span data-dismiss="modal" class="btn btn-link text-muted">بستن</span>
            </div>
            <div class="modal-body">
              <simplebar
                  class="col-xl-12"
                  data-simplebar-auto-hide="false"
                  style="max-height:400px;"
              >
                <form @submit.prevent="uploadExcelFile()" v-if="uploadUserListStatus">
                  <div class="row m-0">
                    <div class="col-md-12 p-0">
                      <label>فایل اکسل</label>
                      <div class="form-group">
                        <input
                            type="file"
                            class="form-control"
                            ref="fu_NewExcelFile"
                            v-on:change="onChangeSelectExcelFile()"
                        />
                      </div>
                    </div>
                  </div>


                  <label>نوع کاربران</label>
                  <div class="form-group">
                    <select
                        class="form-control show-tick ms select2"
                        data-placeholder="انتخاب"
                        style="height:auto;"
                        v-model="usersType"
                    >
                      <option value="Customer">مشتری</option>
                      <option value="Seller">فروشنده</option>
                    </select>
                  </div>
                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >ثبت کن
                  </button>
                </form>
                <div v-else>
                  <div class="body">
                    <p>
                      سطرهایی که دارای سلول خالی میباشند
                      {{ uploadUserListDetail.CellEmpty.length }}
                      {{ uploadUserListDetail.CellEmpty }}
                    </p>
                    <p>
                      سطرهایی که جنسیت آنها معتبر نمیباشد
                      {{ uploadUserListDetail.GenderCell.length }}
                      {{ uploadUserListDetail.GenderCell }}
                    </p>
                    <p>
                      سطرهای که شماره موبایل آنها صحیح نمیباشد
                      {{ uploadUserListDetail.MobileCell.length }}
                      {{ uploadUserListDetail.MobileCell }}
                    </p>
                    <p>
                      سطرهایی که موجودی آنها صحیح نمیباشد
                      {{ uploadUserListDetail.CashCell.length }}
                      {{ uploadUserListDetail.CashCell }}
                    </p>
                    <p>
                      سطرهایی که در فایل اکسل تکراری میباشند
                      {{ uploadUserListDetail.DuplicateRow.length }}
                      {{ uploadUserListDetail.DuplicateRow }}
                    </p>
                    <p>
                      سطرهایی که شماره کارت آنها صحیح نمیباشد
                      {{ uploadUserListDetail.CardNumberCell.length }}
                      {{ uploadUserListDetail.CardNumberCell }}
                    </p>
                    <p class="text-warning">
                      شماره هایی که قبلاً ثبت شده اند
                      {{ uploadUserListDetail.DuplicateUsers.length }}
                      {{ uploadUserListDetail.DuplicateUsers }}
                    </p>
                    <p class="text-success">
                      شماره هایی که با موفقیت ثبت شدند
                      {{ uploadUserListDetail.RegisteredUsers.length }}
                      {{ uploadUserListDetail.RegisteredUsers }}
                    </p>
                    <p class="text-danger">
                      شماره هایی که ثبت آنها با خطا مواجه شد
                      {{ uploadUserListDetail.UsersWithError.length }}
                      {{ uploadUserListDetail.UsersWithError }}
                    </p>
                  </div>
                </div>
              </simplebar>
            </div>
            <!-- <div class="modal-footer">
            <button type="button" class="btn btn-default btn-round waves-effect">ذخیره تغییرات</button>
            <button
              type="button"
              class="btn btn-danger btn-round waves-effect"
              data-dismiss="modal"
            >بستن</button>
            </div>-->
          </div>
        </div>
      </div>

      <div class="modal fade" id="div_EditUserModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content bg-indigo">
            <div class="modal-header justify-content-between pt-3">
              <span class="title">ویرایش علی همتی</span>
              <span data-dismiss="modal" class="btn btn-link text-white">بستن</span>
            </div>
            <div class="modal-body">
              <form>
                <label for="txt_NewUser_FName">نام</label>
                <div class="form-group">
                  <input type="text" id="txt_NewUser_FName" class="form-control"/>
                </div>
                <label for="txt_NewUser_LName">نام خانوادگی</label>
                <div class="form-group">
                  <input type="text" id="txt_NewUser_LName" class="form-control"/>
                </div>
                <label for="txt_NewUser_Mobile">شماره همراه</label>
                <div class="form-group">
                  <input
                      type="text"
                      id="txt_NewUser_Mobile"
                      class="form-control text-left"
                      readonly
                  />
                </div>
                <label for="txt_NewUser_Email">ایمیل</label>
                <div class="form-group">
                  <input type="text" id="txt_NewUser_Email" class="form-control text-left"/>
                </div>
                <div class="checkbox">
                  <input id="chb_NewUser_UserStatus1" type="checkbox"/>
                  <label for="chb_NewUser_UserStatus1">وضعیت کاربر(فعال/غیرفعال)</label>
                </div>
                <button
                    type="button"
                    class="btn btn-raised btn-success btn-round waves-effect"
                >ذخیره کن
                </button>
              </form>
            </div>
            <!-- <div class="modal-footer">
            <button type="button" class="btn btn-default btn-round waves-effect">ذخیره تغییرات</button>
            <button
              type="button"
              class="btn btn-danger btn-round waves-effect"
              data-dismiss="modal"
            >بستن</button>
            </div>-->
          </div>
        </div>
      </div>

      <div class="modal fade" id="div_EditRolesModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header justify-content-between pt-3">
              <span
                  class="title">نقش های {{  userInfo.FullName }}</span>
              <span data-dismiss="modal" class="btn btn-link text-muted">بستن</span>
            </div>
            <div class="modal-body">
              <form @submit.prevent="updateUser(userInfo.Id)">
                <p>نقش های کاربر</p>
                <div class="checkbox" v-for="role in systemRoles" :key="role.Role">
                  <input
                      v-bind:id="role.Role"
                      type="checkbox"
                      v-model="userRoles"
                      :value="role.Role"
                  />
                  <label v-bind:for="role.Role">{{ role.Title }}</label>
                </div>


<!--                <hr>
                <div class="checkbox">
                  <input id="chb_Permission11" type="checkbox" v-model="userInfo.UserActive"/>
                  <label for="chb_Permission11">وضعیت
                    کاربر({{ userInfo.UserActive == true ? "فعال" : "غیرفعال" }})</label>
                </div>

                <div class="checkbox">
                  <input id="chb_SendSms" type="checkbox" v-model="userInfo.SendSms"/>
                  <label for="chb_SendSms">ارسال
                    پیامک({{ userInfo.SendSms == true ? "فعال" : "غیرفعال" }})</label>
                </div>

                <div class="checkbox">
                  <input id="chb_IsRegisterComplete" type="checkbox" v-model="userInfo.IsRegisterComplete"/>
                  <label for="chb_IsRegisterComplete">تکمیل ثبت‌نام
                    ({{ userInfo.IsRegisterComplete == true ? "فعال" : "غیرفعال" }})</label>
                </div>-->

                <!-- <div class="checkbox">
                  <input id="chb_Permission2" type="checkbox" />
                  <label for="chb_Permission2">مدیر</label>
                </div>
                <div class="checkbox">
                  <input id="chb_Permission3" type="checkbox" />
                  <label for="chb_Permission3">کاربر</label>
                </div>-->
                <!-- <p>مجوزهای کاربر</p>
                <div class="checkbox">
                  <input id="chb_Permission4" type="checkbox" />
                  <label for="chb_Permission4">خواندن</label>
                </div>
                <div class="checkbox">
                  <input id="chb_Permission5" type="checkbox" />
                  <label for="chb_Permission5">نوشتن</label>
                </div>
                <div class="checkbox">
                  <input id="chb_Permission6" type="checkbox" />
                  <label for="chb_Permission6">ویرایش</label>
                </div>
                <div class="checkbox">
                  <input id="chb_Permission7" type="checkbox" />
                  <label for="chb_Permission7">حذف</label>
                </div>-->
                <button
                    type="submit"
                    class="btn btn-raised btn-success btn-round waves-effect"
                >ذخیره کن
                </button>
              </form>
            </div>
            <!-- <div class="modal-footer">
            <button type="button" class="btn btn-default btn-round waves-effect">ذخیره تغییرات</button>
            <button
              type="button"
              class="btn btn-danger btn-round waves-effect"
              data-dismiss="modal"
            >بستن</button>
            </div>-->
          </div>
        </div>
      </div>

      <div class="modal fade" id="div_EditPermissionsModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header justify-content-between pt-3">
              <span class="title">مجوزهای کاربر</span>
              <span data-dismiss="modal" class="btn btn-link text-muted">بستن</span>
            </div>
            <div class="modal-body">
              <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                <form>
                  <div class="row" v-for="item in modulesList" :key="item._id">
                    <div class="col-lg-12">
                      <p>
                        <strong>{{ item.Title }}</strong>
                      </p>
                      <div class="checkbox" v-for="route in item.Routes" :key="route._id">
                        <input
                            v-bind:id="'chb_Role_'+route.Name"
                            type="checkbox"
                            v-model="userEditPermissions"
                            :value="route.Name"
                            @change="updateUserModulesList(userId,route.Name,item._id,$event)"
                        />
                        <label v-bind:for="'chb_Role_'+route.Name">{{ route.Title }}</label>
                      </div>
                    </div>
                  </div>

                  <!-- <button
                    type="submit"
                    class="btn btn-raised btn-success btn-round waves-effect"
                  >ذخیره کن</button>-->
                </form>
              </simplebar>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="div_ChangeUserPasswordModal">
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content border-0">
            <div class="modal-header p-2 bg-success">
              <h6 class="modal-title text-white mt-0">تغییر رمز عبور</h6>
              <a href="#" class="text-left text-white" data-dismiss="modal">بستن</a>
            </div>
            <div class="modal-body text-center">
              <form v-on:submit.prevent="changeUserPassword(userId)">
                <div class="form-group row m-0">
                  <!-- <label for="EditNewPassword" class="col-4 col-form-label">رمز عبور جدید</label> -->
                  <div class="col-12 text-right align-self-center">
                    <input
                        type="password"
                        class="form-control text-left"
                        id="EditNewPassword"
                        v-model="newPassword"
                        placeholder="رمز عبور جدید"
                    />
                  </div>
                </div>
                <div class="form-group row m-0">
                  <div class="col-12 mt-4">
                    <button type="submit" class="btn btn-success btn-block">تغییر بده</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="div_UserInfoModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header justify-content-between pt-3">
              <span class="title" id="defaultModalLabel">اطلاعات کاربر</span>
              <span data-dismiss="modal" class="btn btn-link text-muted">بستن</span>
            </div>
            <div class="modal-body">
              <simplebar
                  class="col-xl-12"
                  data-simplebar-auto-hide="false"
                  style="max-height:400px;"
              >
                <label>نام</label>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="userInfo.FirstName" disabled/>
                </div>
                <label>نام خانوادگی</label>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="userInfo.LastName" disabled/>
                </div>
                <label>کدملی</label>
                <div class="form-group">
                  <input
                      type="text"
                      class="form-control text-left"
                      v-model="userInfo.NationalCode"
                      disabled
                  />
                </div>

                <label>جنسیت</label>
                <div class="form-group">
                  <select
                      class="form-control show-tick ms select2"
                      data-placeholder="انتخاب"
                      style="height:auto;"
                      v-model="userInfo.Gender"
                      disabled
                  >
                    <option value="true">آقا</option>
                    <option value="false">خانم</option>
                  </select>
                </div>

                <label>شماره همراه</label>
                <div class="form-group">
                  <input
                      type="text"
                      class="form-control text-left"
                      v-model="userInfo.Mobile"
                      disabled
                  />
                </div>


                <label>شماره کارت</label>
                <div class="form-group">
                  <input
                      type="text"
                      class="form-control text-left"
                      v-model="userInfo.CardNumber"
                      disabled
                  />
                </div>


                <label>کد پرسنلی</label>
                <div class="form-group">
                  <input
                      type="text"
                      class="form-control text-left"
                      v-model="userInfo.PersonelCode"
                      disabled
                  />
                </div>

                <label>ایمیل/نام کاربری</label>
                <div class="form-group">
                  <input
                      type="text"
                      class="form-control text-left"
                      v-model="userInfo.Email"
                      disabled
                  />
                </div>
                <label>آدرس</label>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="userInfo.Address" disabled/>
                </div>
                <label>کدپستی</label>
                <div class="form-group">
                  <input
                      type="text"
                      class="form-control text-left"
                      v-model="userInfo.PostalCode"
                      disabled
                  />
                </div>
                <label>تاریخ ثبت نام</label>
                <div class="form-group">
                  <span
                      class="form-control"
                      style="padding-top:10px;text-align: left;"
                  >{{ userInfo.RegisterDate | moment("HH:mm - jYYYY/jM/jD") }}</span>
                </div>
                <label v-if="userInfo.SmsCode && userInfo.SmsCode.length>0">آخرین پیامک</label>
                <div class="form-group" v-if="userInfo.SmsCode && userInfo.SmsCode.length>0">
                  <span
                      class="form-control"
                      style="padding-top:10px;text-align: left;"
                  >{{ userInfo.SmsCode[userInfo.SmsCode.length - 1].Code }}</span>
                </div>

                <div class="checkbox">
                  <input id="chb_UserStatus" type="checkbox" v-model="userInfo.UserActive" disabled/>
                  <label for="chb_UserStatus">
                    وضعیت کاربر
                    {{ (userInfo.UserActive == true ? "فعال" : "غیرفعال") }}
                  </label>
                </div>

              </simplebar>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="div_UserCashModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header justify-content-between pt-3">
              <span class="title">اعتبار کاربر</span>
              <span data-dismiss="modal" class="btn btn-link text-muted">بستن</span>
            </div>
            <div class="modal-body">
              <simplebar
                  class="col-xl-12"
                  data-simplebar-auto-hide="false"
                  style="max-height:500px;"
              >
                <form @submit.prevent="updateUserCash()">

                  <label>اعتبارفعلی کارت اعتباری(ریال)</label>
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="userInfo.Cash" disabled/>
                  </div>
                  <label>اعتبارفعلی کیف پول(ریال)</label>
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="userInfo.Wallet" disabled/>
                  </div>
                  <div class="col-md-12">
                    <label>نوع تراکنش را مشخص نمایید</label>
                    <div class="form-group">
                      <div class="radio inlineblock m-r-20">
                        <input
                            type="radio"
                            name="transactionType"
                            class="with-gap"
                            :value="true"
                            id="decreaseCash"
                            v-model="userCash.TransactionType"
                        />
                        <label for="decreaseCash">افزایش موجودی</label>
                      </div>
                      <div class="radio inlineblock">
                        <input
                            type="radio"
                            name="transactionType"
                            class="with-gap"
                            :value="false"
                            id="increaseCash"
                            v-model="userCash.TransactionType"
                        />
                        <label for="increaseCash">کاهش موجودی</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label>کارت اعتباری/کیف پول</label>
                    <div class="form-group">
                      <div class="radio inlineblock m-r-20">
                        <input
                            type="radio"
                            name="targetTransaction"
                            class="with-gap"
                            :value="2"
                            id="Wallet"
                            v-model="userCash.TargetOperation"
                        />
                        <label for="Wallet">کیف پول</label>
                      </div>
                      <div class="radio inlineblock">
                        <input
                            type="radio"
                            name="targetTransaction"
                            class="with-gap"
                            :value="1"
                            id="CreditCard"
                            v-model="userCash.TargetOperation"
                        />
                        <label for="CreditCard">کارت اعتباری</label>
                      </div>

                    </div>
                  </div>
                  <label>مبلغ(ریال)</label>
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="userCash.TransactionValue"/>
                  </div>
                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >ثبت کن
                  </button>
                </form>
              </simplebar>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="div_UserSearchModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header justify-content-between pt-3">
              <span class="title">جستجوی کاربر</span>
              <span data-dismiss="modal" class="btn btn-link text-muted">بستن</span>
            </div>
            <div class="modal-body">
              <simplebar
                  class="col-xl-12"
                  data-simplebar-auto-hide="false"
                  style="max-height:400px;"
              >
                <form @submit.prevent="userSearch()">
                  <label>تلفن همراه</label>
                  <div class="form-group">
                    <input type="text" class="form-control text-left"
                           v-model="userSearchParams.Mobile"/>
                  </div>
                  <!-- <label>آدرس ایمیل</label>
                   <div class="form-group">
                       <input type="text" class="form-control" v-model="userSearchParams.Email"/>
                   </div>-->
                  <label>شماره کارت</label>
                  <div class="form-group">
                    <input type="text" class="form-control text-left"
                           v-model="userSearchParams.CardNumber"/>
                  </div>
                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >جستجوکن
                  </button>
                </form>
              </simplebar>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="div_UpdateUserCashFromExcelModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header justify-content-between pt-3">
              <span class="title">بروزرسانی حساب‌های مشتریان</span>
              <span data-dismiss="modal" class="btn btn-link text-muted">بستن</span>
            </div>
            <div class="modal-body">
              <simplebar
                  class="col-xl-12"
                  data-simplebar-auto-hide="false"
                  style="max-height:400px;"
              >
                <form @submit.prevent="updateUserCashFromExcelFile()"
                      v-if="updateUserCashFromExcelStatus">
                  <div class="row m-0">
                    <div class="col-md-12 p-0">
                      <label>فایل اکسل</label>
                      <div class="form-group">
                        <input
                            type="file"
                            class="form-control"
                            ref="fu_UpdateUserCashExcelFile"
                            v-on:change="onChangeSelectUpdateUserCashExcelFile()"
                        />
                      </div>
                    </div>
                  </div>


                  <!--<label>نوع کاربران</label>
                  <div class="form-group">
                      <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب"
                              style="height:auto;"
                              v-model="usersType"
                      >
                          <option value="Seller">فروشنده</option>
                          <option value="Customer">مشتری</option>
                      </select>
                  </div>-->
                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >ثبت کن
                  </button>
                </form>
                <div v-else>
                  <div class="body">
                    <p>

                      {{ updateUserCashDetail.EmptyCell.length }}
                      ردیف های که دارای سلول خالی میباشد
                      {{ updateUserCashDetail.EmptyCell }}
                    </p>
                    <p>

                      {{ updateUserCashDetail.CashCell.length }}
                      ردیف های که اعتبار آنها صحیح نمیباشد
                      {{ updateUserCashDetail.CashCell }}
                    </p>
                    <p>
                      {{ updateUserCashDetail.CardNumberCell.length }}
                      ردیف هایی که شماره کارت آنها صحیح نمیباشد
                      {{ updateUserCashDetail.CardNumberCell }}
                    </p>
                    <p>
                      {{ updateUserCashDetail.DuplicateRow.length }}
                      ردیف هایی که تکراری میباشند
                      {{ updateUserCashDetail.DuplicateRow }}
                    </p>
                    <p>
                      {{ updateUserCashDetail.NotFoundCustomer.length }}
                      کارت هایی که در سامانه وجود ندارند
                      {{ updateUserCashDetail.NotFoundCustomer }}
                    </p>
                    <p>
                      {{ updateUserCashDetail.UserChanged.length }}
                      کارت هایی که با موفقیت آپدیت شد
                      {{ updateUserCashDetail.UserChanged }}
                    </p>
                    <p>
                      {{ updateUserCashDetail.ErrorWithUser.length }}
                      کارت هایی که آپدیت آنها با خطا مواجه شد
                      {{ updateUserCashDetail.ErrorWithUser }}
                    </p>

                  </div>
                </div>
              </simplebar>
            </div>

          </div>
        </div>
      </div>

      <div class="modal fade" id="div_EditCustomerModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header justify-content-between pt-3">
              <span class="title">ویرایش {{ userInfo.FirstName + " " + userInfo.LastName }}</span>
              <span data-dismiss="modal" class="btn btn-link text-muted">بستن</span>
            </div>
            <div class="modal-body">
              <simplebar
                  class="col-xl-12"
                  data-simplebar-auto-hide="false"
                  style="max-height:400px;"
              >
                <form @submit.prevent="updateCustomer()">
                  <label>نام</label>
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="userInfo.FirstName" required/>
                  </div>
                  <label>نام خانوادگی</label>
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="userInfo.LastName" required/>
                  </div>


                  <label>شناسه بله</label>
                  <div class="form-group">
                    <input type="text" class="form-control text-left" v-model="userInfo.BaleUID"/>
                  </div>


                  <label>رمز عبور جدید</label>
                  <div class="form-group">
                    <input type="password" class="form-control text-left" v-model="userInfo.Password" required/>
                  </div>


                  <!-- <label>شماره کارت</label>

                 <div class="form-group">
                    <div class="checkbox">
                      <input id="chb_EditAutoCardNumber" type="checkbox" v-model="userInfo.AutoGenerateCardNumber"/>
                      <label for="chb_EditAutoCardNumber">
                        {{ userInfo.AutoGenerateCardNumber == true ? "سیستمی" : "بانکی" }}

                      </label>
                    </div>
                    <input type="text" class="form-control text-left"
                           v-model="userInfo.CardNumber"/>
                  </div>-->



<!--                  <label>کد پرسنلی</label>
                  <div class="form-group">
                    <input type="text" class="form-control text-left"
                           v-model="userInfo.PersonelCode" disabled/>
                  </div>-->

<!--                  <label>سازمان طرف قرارداد</label>
                  <div class="form-group">
                    <v-select
                        :getOptionLabel="option => option.Title"
                        :options="organizationCategory" v-model="userInfo.OrganizationCategory"
                    >
                      <template slot="option" slot-scope="option">
                        <span class="fa">{{ `${option.Title}` }}</span>
                      </template>
                    </v-select>

                  </div>-->


<!--                  <label>کدپذیرندگی</label>
                  <div class="form-group">
                    <input type="text" class="form-control text-left"
                           v-model="userInfo.AcceptanceCode" pattern=".{9,9}"/>
                  </div>-->

                  <!--  <label>ایمیل/نام کاربری</label>
                    <div class="form-group">
                        <input type="text" class="form-control text-left" v-model="userFields.Email"/>
                    </div>
                    <label>رمزعبور</label>
                    <div class="form-group">
                        <input
                                type="password"
                                class="form-control text-left"
                                v-model="userFields.Password"
                                v-if="authType=='Tradition'"
                        />
                    </div>
                    <div class="checkbox">
                        <input id="chb_UserStatus" type="checkbox" v-model="userFields.UserActive"/>
                        <label for="chb_UserStatus">
                            وضعیت کاربر
                            {{(userFields.UserActive==true?"فعال":"غیرفعال")}}
                        </label>
                    </div>-->
                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >ذخیره کن
                  </button>
                </form>
              </simplebar>
            </div>
            <!-- <div class="modal-footer">
            <button type="button" class="btn btn-default btn-round waves-effect">ذخیره تغییرات</button>
            <button
              type="button"
              class="btn btn-danger btn-round waves-effect"
              data-dismiss="modal"
            >بستن</button>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import Paginate from 'vuejs-paginate';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  data() {
    return {
      userList: [],
      userInfo: {},
      systemRoles: [
        {Title: "کاربر ارشد", Role: "6"},
        {Title: "راننده", Role: "1"},
        {Title: "نصاب", Role: "2"},
        {Title: "صندوق دار", Role: "3"},
        {Title: "کارگاه", Role: "4"},
        {Title: "مالی", Role: "5"},
        {Title: "انبار", Role: "8"},
        {Title: "حسابداری", Role: "9"},
        {Title: "فروشنده", Role: "10"},
        {Title: "تحویل نشده", Role: "11"},
        {Title: "رضایت سنجی", Role: "12"}
        // {Title: "مدیر فروشگاه", Role: "Seller"},
        // {Title: "فروشنده فروشگاه", Role: "Vendor"},
        // {Title: "واحد فروش", Role: "SalesDepartment"},
        // {Title: "واحد مالی", Role: "CounterBilling"},//این برای دفاتر پیشخوان میباشد
        // {Title: "میز خدمت", Role: "ServiceDesk"},//این برای دفاتر پیشخوان میباشد
        // {Title: "واحد اعتبارات", Role: "CounterCredits"},//این برای دفاتر پیشخوان میباشد
        // {Title: "واحد اداری", Role: "CounterOfficial"},//این برای دفاتر پیشخوان میباشد
        // {Title: "واحد تخصیص اعتبار", Role: "CreditAllocation"},//این برای دفاتر پیشخوان میباشد
        // {Title: "واحد تبلیغات", Role: "AdvertisingUnit"},//این برای برای واحد تبلیغات در نظر گرفته شده است
        // {Title: "واحد فناوری اطلاعات", Role: "ITUnit"},//این برای برای واحد فناوری اطلاعات در نظر گرفته شده است
        // {Title: "مدیر دفاتر پیشخوان", Role: "CounterManager"},//این برای دفاتر پیشخوان میباشد
        // {Title: "متصدی دفتر پیشخوان", Role: "CounterOfficeOperator"},//این برای دفاتر پیشخوان میباشد
        // {Title: "مشتری اعتباری", Role: "CreditCustomer"},//مشتری اعتباری
        // {Title: "مشتری کیف پول", Role: "CashCustomer"},//مشتری کیف پول
        // {Title: "مشاهده اقساط", Role: "ViewInstallments"},//با این دسترسی مشتری میتواند اقساط خود را مشاهده نماید
      ],
      userRoles: [],
      userId: "",
      newPassword: "",
      modulesList: [],
      userEditPermissions: [],
      loadingShow: false,
      pageSize: 10,
      pageList: 0,
      pageIndex: undefined,
      userData: {UserList: [], UserCount: 0},
      authType: "",
      userFields: {
        FirstName: "",
        LastName: "",
        Email: null,
        Mobile: "",
        Password: null,
        Gender: true,
        UserActive: true,
        CardNumber: "",
        NationalCode: null,
        PersonelCode: null,
        AcceptanceCode: null,
        AutoGenerateCardNumber: false,
        OrganizationCategory: null
      },
      usersType: "Customer",
      excelFile: "",
      userCashExcelFile: "",
      uploadUserListStatus: true,
      uploadUserListDetail: {},
      updateUserCashDetail: {},
      userCash: {
        TransactionType: true,
        TransactionValue: 0,
        _id: null,
        TargetOperation: 2
      },
      userSearchMode: false,
      userSearchParams: {
        Mobile: null,
        Email: null,
        CardNumber: null
      },
      updateUserCashFromExcelStatus: true,
      organizationCategory: []

      //userPermissions: []
      // userInfo: {
      //   FirstName: "",
      //   LastName: "",
      //   Email: "",
      //   Mobile: "",
      //   Address: "",
      //   NationalCode: "",
      //   PostalCode: "",
      //   RegisterDate: "",
      //   UserActive: false,
      //   Roles: []
      // }
    };
  },
  methods: {
    splitDebitCartNumber(cartNumber) {
      let numArray = cartNumber.match(/.{1,4}/g);
      let newCartNumber = "";
      for (let i of numArray) {
        newCartNumber += i + "—";
      }
      return newCartNumber.substring(0, newCartNumber.length - 1)
    },
    splitDigit(val) {
      val += '';
      val = val.replace(',', '');
      let x = val.split('.');
      let y = x[0];
      let z = x.length > 1 ? '.' + x[1] : '';
      let rgx = /(\d+)(\d{3})/;
      while (rgx.test(y))
        y = y.replace(rgx, '$1' + ',' + '$2');
      return y + z;
    },
    getOrganizationCategory() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = false;
      axios
          .get(`/Panel/V2/Users/GetOrganizationCategory`, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            if (res.data.Status === 1) {
              self.organizationCategory = res.data.Data.OrganizationCategory;
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: res.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
            //console.log(error);
          })
          .finally(function (params) {
            self.loadingShow = false;
          });
    },
    getUserList(pageIndex = 1, limit = 10) {
      // console.log("TESTTTT");
      let self = this;
      self.pageIndex = pageIndex;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get("https://araksolar.ir/webhook/GetUserList", {
            params: {
              /*PageIndex: pageIndex,
              Limit: limit*/
            },
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            console.log(res.data);
            self.userData.UserList = res.data;
            /*self.userData.UserCount = response.data.Data.UserCount;
            let pageCount =
                self.userData.UserCount % self.pageSize == 0
                    ? self.userData.UserCount / self.pageSize
                    : self.userData.UserCount / self.pageSize + 1;
            self.pageList = Math.floor(pageCount);*/
          })
          .catch(function (error) {
          })
          .finally(function (params) {
            self.loadingShow = false;
          });
    },
    getUser(id) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get(`https://araksolar.ir/webhook/GetUserRoles`, {
            params: {
              _id: id
            },
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            console.log(res.data);
            self.userRoles = res.data[0].Roles;
            self.userInfo = res.data[0].UserInfo;
            /*if (res.data.Status == 1) {
              console.log(response.data);

              self.userRoles = response.data.Data.User.Roles;
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }*/
          })
          .catch(function (error) {
            //console.log(error);
          })
          .finally(function (params) {
            self.loadingShow = false;
          });
    },
    updateUser(id) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      let formData = {
        Roles: self.userRoles,
        Id: id
      };
      self.loadingShow = true;
      axios
          .post(`https://araksolar.ir/webhook/UpdateUserRoles`, formData, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            console.log(res.data);

            /*if (response.data.Status === 1) {
              self.getUserList(self.pageIndex);
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }*/
          })
          .catch(function (error) {
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    updateCustomer() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      // console.log(self.userInfo);
      // return;
      self.loadingShow = true;
      axios
          .post(`https://araksolar.ir/webhook/UpdateUser`, {User: self.userInfo}, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            const {Data,Status,Message}=res.data[0];
            if (Status===1){
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
            }
            else{
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "error",
                duration: 5000
              });
            }
            $("#div_EditCustomerModal").modal("hide");
            //console.log(response.data);
            self.getUserList();
            /*if (response.data.Status === 1) {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "success",
                duration: 5000
              });
              $("#div_EditCustomerModal").modal("hide");
              self.userInfo = {};

              self.getUserList();
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }*/
          })
          .catch(function (error) {
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    openChangeUserPasswordModal(id) {
      this.userId = id;
      $("#div_ChangeUserPasswordModal").modal("show");
    },
    changeUserPassword(id) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      let formData = {
        NewPassword: self.newPassword,
        _id: id
      };
      self.loadingShow = true;
      axios
          .patch(`/ChangePasswordAdmin`, formData, {
            headers: {authorization: userInfo.Token}
          })
          .then(function (response) {
            if (response.data.Status == 1) {
              self.$toast.open({
                position: "bottom-right",
                message: "رمز عبور کاربر با موفقیت تغییریافت",
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
            self.$toast.open({
              position: "bottom-right",
              message: "خطا!دوباره تلاش نمایید",
              type: "error",
              duration: 5000
            });
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    getPermissionsList(id) {
      var self = this;
      var userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      axios
          .get("/GetModules", {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            self.modulesList = response.data.Data;
            var formData = {
              Users: self.userId
            };
            self.loadingShow = true;
            axios
                .get("/GetUserRoutes", {
                  params: {Users: self.userId},
                  headers: {
                    authorization: userInfo.Token
                  }
                })
                .then(function (response) {
                  if (response.data.Status == 1) {
                    var routes = response.data.Data;
                    self.userEditPermissions = [];
                    routes.forEach(element => {
                      self.userEditPermissions.push(element.Route);
                    });
                  } else {
                    self.$toast.open({
                      position: "bottom-right",
                      message: response.data.Message,
                      type: "error",
                      duration: 5000
                    });
                  }
                })
                .catch(function (error) {
                })
                .finally(function (params) {
                  self.loadingShow = false;
                });
          })
          .catch(function (error) {
          });
    },
    openEditPermissionsModal(id) {
      var self = this;
      self.userId = id;
      self.getPermissionsList(id);
      $("#div_EditPermissionsModal").modal("show");
    },
    updateUserModulesList(par1, par2, par3, $event) {
      //console.log(par1, par2, par3, $event.target.checked);
      var self = this;
      var userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      var formData = {
        Users: self.userId,
        Route: par2,
        Modules: par3,
        Operation: $event.target.checked
      };
      self.loadingShow = true;
      axios
          .post(`/UpdateUserRoutes`, formData, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            //console.log(response.data);

            if (response.data.Status == 1) {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    openNewUserFromExcelModal() {
      let self = this;
      self.uploadUserListStatus = true;
      this.excelFile = null;
      $("#div_NewUsersFromExcelModal").modal("show");

    },
    openUpdateUserCashModal() {
      let self = this;
      self.updateUserCashFromExcelStatus = true;
      self.userCashExcelFile = "";
      $("#div_UpdateUserCashFromExcelModal").modal("show");
    },
    openNewUserModal() {
      let self = this;
      //self.getAuthType();
      // self.getOrganizationCategory();
      $("#div_NewUserModal").modal("show");
    },
    getAuthType() {
      var self = this;
      self.loadingShow = true;
      axios
          .get("/getAuthType")
          .then(function (response) {
            //console.log(response.data);
            self.authType = response.data.Data;
          })
          .catch(function (error) {
          })
          .finally(function (params) {
            self.loadingShow = false;
          });
    },
    addUser() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .post(`https://araksolar.ir/webhook/AddUser`, self.userFields, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            //console.log(response.data);
            let {Status,Message,Data}=response.data[0];
            if (Status === 1) {
              self.userFields = {
                FirstName: "",
                LastName: "",
                Email: null,
                Mobile: "",
                Password: null,
                Gender: true,
                UserActive: true,
                CardNumber: "",
                NationalCode: null,
                PersonelCode: null,
                AcceptanceCode: null,
                AutoGenerateCardNumber: false,
                OrganizationCategory: null
              };
              $("#div_NewUserModal").modal("hide");
              self.getUserList();
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    openUserInfoModal(id) {
      var self = this;
      self.getUser(id);
      $("#div_UserInfoModal").modal("show");
    },
    openEditRolesUser(id) {
      let self = this;
      self.getUser(id);
      $("#div_EditRolesModal").modal("show");
    },
    onChangeSelectExcelFile() {
      this.excelFile = this.$refs.fu_NewExcelFile.files[0];
    },
    onChangeSelectUpdateUserCashExcelFile() {
      this.userCashExcelFile = this.$refs.fu_UpdateUserCashExcelFile.files[0];
    },
    uploadExcelFile() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      let formData = new FormData();
      formData.append("ExcelFile", self.excelFile);
      formData.append("UsersType", self.usersType);


      self.loadingShow = true;
      this.axios
          .post("/AddUsersFromExcelFile", formData, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            console.log(response.data);
            if (response.data.Status === 1) {
              self.uploadUserListStatus = false;
              self.uploadUserListDetail = response.data.Data;
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function () {
            self.$toast.open({
              position: "bottom-right",
              message: "خطای نامعلومی رخ داده است",
              type: "error",
              duration: 5000
            });
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    openUserCashModal(id) {
      let self = this;
      self.getUser(id);
      $("#div_UserCashModal").modal("show");
    },
    openEditCustomerModal(id) {
      let self = this;
      self.getUser(id);
      //self.getOrganizationCategory();
      $("#div_EditCustomerModal").modal("show");
    },
    updateUserCash() {
      let self = this;
      // alert("mmmmmmmmmmm")

      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));

      self.userCash._id = self.userInfo._id;


      self.loadingShow = true;
      axios
          .post(`/UpdateUserCash`, self.userCash, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            // console.log(response.data);
            if (response.data.Status === 1) {
              self.userSearch();
              $("#div_UserCashModal").modal("hide");
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    openUserSearchModal() {
      $("#div_UserSearchModal").modal("show");
    },
    userSearch() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.userSearchMode = true;
      self.loadingShow = true;
      axios
          .post(`/UserSearch`, self.userSearchParams, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            console.log(response.data);
            if (response.data.Status === 1) {
              self.userData.UserList = response.data.Data.UserList;
              self.userData.UserCount = response.data.Data.UserCount;
              let pageCount = self.userData.UserCount % self.pageSize === 0
                  ? self.userData.UserCount / self.pageSize
                  : self.userData.UserCount / self.pageSize + 1;
              self.pageList = Math.floor(pageCount);
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function () {
            console.log("Error");
            self.loadingShow = false;
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    removeUserSearchMode() {
      this.userSearchMode = false;
      this.getUserList();
    },
    updateUserCashFromExcelFile() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      let formData = new FormData();
      formData.append("ExcelFile", self.userCashExcelFile);
      // formData.append("UsersType", self.usersType);


      self.loadingShow = true;
      this.axios
          .post("/UpdateUserCashFromExcel", formData, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            console.log(response.data);
            if (response.data.Status === 1) {
              self.updateUserCashFromExcelStatus = false;
              self.updateUserCashDetail = response.data.Data;
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function () {
            self.$toast.open({
              position: "bottom-right",
              message: "خطای نامعلومی رخ داده است",
              type: "error",
              duration: 5000
            });
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
  },
  watch: {
    pageSize: function (val) {
      //this.getUserList(this.pageIndex, this.pageSize);
    }
  },
  created() {
    this.getUserList();
  },
  components: {simplebar, 'paginate': Paginate, 'v-select': vSelect}
};
</script>

<style>
/* @import "../../../public/assets/plugins/jquery-datatable/dataTables.bootstrap4.min.css"; */
.custom-pagination {
  list-style: none;
}

.custom-pagination li {
  list-style: none;
  margin: 0px 10px;
  display: inline;
}

.custom-pagination li a {
  color: #45494a;
}

.custom-pagination li.active {
  background-color: #FF9948;
  border-color: #FF9948;
  font-size: 14px;
  border-radius: 30px !important;
  padding: 3px 11px;
  margin: 0 3px;
  min-width: 30px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  text-transform: uppercase;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
  color: #fff;
}
</style>
